import { createAction } from '@reduxjs/toolkit';

import { EventSearchArgs } from '@/types/calendar/events';
import { FilterPreset, FilterPresetDisplay } from '@/types/filter-presets';
import { FilterItem } from '@/types/filters';
import { WithCities } from '@/types/platform-data';

import { Filters } from './calendar-filters.types';

export const calendarFiltersKey = 'calendarFilters';

export interface CalendarFiltersState {
    readonly filtersAvailable: Filters;
    readonly filtersSelected: Filters;
    readonly filterPreset: FilterPreset<FilterPresetDisplay> | null;
    readonly searchArgs: EventSearchArgs;
}

export enum CalendarFiltersActionTypes {
    filtersLoad = 'calendarFilters/filtersLoad',
    filtersLoadSuccess = 'calendarFilters/filtersLoadSuccess',

    filterSelect = 'calendarFilters/filterSelect',
    filterDeselect = 'calendarFilters/filterDeselect',
    filtersReset = 'calendarFilters/filtersReset',

    searchStringSet = 'calendarFilters/searchStringSet',
    searchRangeSet = 'calendarFilters/searchRangeSet',
    searchSortByScoreSet = 'calendarFilters/searchSortSet',
}

export const filtersLoad = createAction<WithCities<{ filterPresetId?: string | null }>>(
    CalendarFiltersActionTypes.filtersLoad,
);
export const filtersLoadSuccess = createAction<{ filters: Filters; filterPreset: FilterPreset | null }>(
    CalendarFiltersActionTypes.filtersLoadSuccess,
);

export const searchStringSet = createAction<string>(CalendarFiltersActionTypes.searchStringSet);
export const searchRangeSet = createAction<boolean>(CalendarFiltersActionTypes.searchRangeSet);

export const searchSortByScoreSet = createAction<boolean>(CalendarFiltersActionTypes.searchSortByScoreSet);

export const filterSelect = createAction<FilterItem>(CalendarFiltersActionTypes.filterSelect);
export const filterDeselect = createAction<FilterItem>(CalendarFiltersActionTypes.filterDeselect);
export const filtersReset = createAction(CalendarFiltersActionTypes.filtersReset);

export type CalendarFiltersActions =
    | ReturnType<typeof filtersLoad>
    | ReturnType<typeof filtersLoadSuccess>
    | ReturnType<typeof filterSelect>
    | ReturnType<typeof filterDeselect>
    | ReturnType<typeof filtersReset>
    | ReturnType<typeof searchRangeSet>
    | ReturnType<typeof searchSortByScoreSet>
    | ReturnType<typeof searchStringSet>;
